import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { routes } from '../../routes';
import { images } from '../../assets/images';
import HomePageController from '../../apis/controller/homePage.controller';
import Validation from '../helper/validation';
// import { Link, NavLink } from 'react-router-dom';

const Footer = () => {
    // render() {
    const [homepage, setHomepage] = useState();
    const [loader, setLoader] = useState(false);
    let defaultValues = {
        email: null,
    };
    const [values, setValues] = useState(defaultValues);

    const [isError, setError] = useState({
        email: {
            rules: ["required", "email"],
            isValid: true,
            message: "",
        },
    });
    let validation = new Validation(isError);

    const handleStates = (field, value) => {
        /** Validate each field on change */
        let node = validation.validateField(field, value);
        setError({ ...isError, [field]: node });
        /** Validate each field on change */
        if (!value || !value.trim()) {
            setValues({ ...values, [field]: "" });
        } else {
            setValues({ ...values, [field]: value });
        }
    };
    useEffect(() => {
        getHomepage();
    }, []);

    const getHomepage = async () => {
        setLoader(true);
        let res = await new HomePageController().homePage();
        if (res && res.status) {
            setHomepage(res.home_page);
        }
        setLoader(false);
    };

    // console.log('aaaaaaaaaa', homepage.footer_section);
    return (
        <div className="footer_section">
            {homepage && homepage.footer_section ? <Container>
                <Row>
                    <Col>
                        <div className="footer_area">
                            <Row>
                                <Col xl={3} lg={{ span: 3, order: 1 }} md={6} sm={12} xs={12}>
                                    {homepage.footer_section.contact_info ? <div className="footer_item">
                                        <div className="footer_title">
                                            <h4>{homepage.footer_section.contact_info.title}</h4>
                                        </div>
                                        <div className="contact_info">
                                            <ul>
                                                <li>
                                                    <i className="fal fa-map-marker-alt"></i>
                                                    <div>
                                                        <Link to={{ pathname: "https://goo.gl/maps/Zef32RjAP1RbV3DE7" }} target="_blank">
                                                            {/* Tech Cruizers Private Limited <br />
                                                            #123, Lorem ipsum Location, City, State, Country - 123456 */}
                                                            {homepage.footer_section.contact_info.address}
                                                        </Link>
                                                    </div>
                                                </li>
                                                <li>
                                                    <i className="fal fa-phone-alt"></i>
                                                    <div>
                                                        {/* <Link to={{ pathname: "https://goo.gl/maps/Zef32RjAP1RbV3DE7" }}> */}
                                                        {/* +91-8968628088 */}
                                                        <a href={`tel: ${homepage.footer_section.contact_info.phone_number_1}`}>
                                                            {homepage.footer_section.contact_info.phone_number_1}
                                                        </a>
                                                        {/* </Link> */}
                                                    </div>
                                                </li>
                                                <li>
                                                    <i className="fal fa-phone-alt"></i>
                                                    <div>
                                                        {/* <Link to={{ pathname: "https://goo.gl/maps/Zef32RjAP1RbV3DE7" }}> */}
                                                        {/* +91-8054964656 */}
                                                        <a href={`tel: ${homepage.footer_section.contact_info.phone_number_2}`}>
                                                            {homepage.footer_section.contact_info.phone_number_2}
                                                        </a>
                                                        {/* </Link> */}
                                                    </div>
                                                </li>
                                                <li>
                                                    <i className="fal fa-envelope"></i>
                                                    <div>
                                                        {/* <Link to={{ pathname: "https://goo.gl/maps/Zef32RjAP1RbV3DE7" }}> */}
                                                        {/* info@techcruizer.com */}
                                                        <a href={`mailto:${homepage.footer_section.contact_info.email}`}>
                                                            {homepage.footer_section.contact_info.email}
                                                        </a>
                                                        {/* </Link> */}
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div> : null}
                                </Col>
                                <Col xl={3} lg={{ span: 3, order: 3 }} md={6} sm={12} xs={12}>
                                    <div className="footer_item">
                                        <div className="footer_title">
                                            <h4>Newsletter</h4>
                                        </div>
                                        <div className="newsletter_form">
                                            <Form>
                                                <Form.Group controlId="exampleForm.ControlInput1">
                                                    <Form.Control type="email" placeholder="Enter Your E-mail"
                                                        onChange={(e) => {
                                                            handleStates(
                                                                "email",
                                                                e.target.value
                                                            );
                                                        }}
                                                        value={
                                                            values.email
                                                                ? values.email
                                                                : ``
                                                        } />
                                                    {isError.email.message ? (
                                                        <p className="valid-helper">
                                                            {isError.email.message}
                                                        </p>
                                                    ) : null}
                                                </Form.Group>
                                                <div className="secondary_btn mt-2">
                                                    <Button type="submit">Subscribe</Button>
                                                </div>
                                            </Form>
                                        </div>
                                        {homepage.footer_section.follow_us ? <div className="footer_title mb-3">
                                            <h4>{homepage.footer_section.follow_us.title}</h4>
                                        </div> : null}
                                        {homepage.footer_section.follow_us ? <div className="social_icons">
                                            <ul className="list-inline">
                                                <li>
                                                    {/* <Link to={{ pathname: homepage.footer_section.follow_us.facebook }} target="_blank"> */}
                                                    <a href={homepage.footer_section.follow_us.facebook}>
                                                        <i className="fab fa-facebook-f"></i>
                                                    </a>
                                                    {/* </Link> */}
                                                </li>
                                                <li>
                                                    {/* <Link to={{ pathname: homepage.footer_section.follow_us.twitter }} target="_blank"> */}
                                                    <a href={homepage.footer_section.follow_us.twitter}>
                                                        <i className="fab fa-twitter"></i>
                                                    </a>
                                                    {/* </Link> */}
                                                </li>
                                                <li>
                                                    {/* <Link to={{ pathname: homepage.footer_section.follow_us.linkedin }} target="_blank"> */}
                                                    <a href={homepage.footer_section.follow_us.linkedin}>
                                                        <i className="fab fa-linkedin-in"></i>
                                                    </a>
                                                    {/* </Link> */}
                                                </li>
                                                <li>
                                                    {/* <Link to={{ pathname: homepage.footer_section.follow_us.youtube }} target="_blank"> */}
                                                    <a href={homepage.footer_section.follow_us.youtube}>
                                                        <i className="fab fa-youtube"></i>
                                                    </a>
                                                    {/* </Link> */}
                                                </li>
                                                <li>
                                                    {/* <Link to={{ pathname: homepage.footer_section.follow_us.blogger }} target="_blank"> */}
                                                    <a href={homepage.footer_section.follow_us.blogger}>
                                                        <i className="fab fa-blogger"></i>
                                                    </a>
                                                    {/* </Link> */}
                                                </li>
                                                <li>
                                                    {/* <Link to={{ pathname: homepage.footer_section.follow_us.google }} target="_blank"> */}
                                                    <a href={homepage.footer_section.follow_us.google}>
                                                        <i className="fab fa-google-plus-g"></i>
                                                    </a>
                                                    {/* </Link> */}
                                                </li>
                                                <li>
                                                    {/* <Link to={{ pathname: homepage.footer_section.follow_us.telegram }} target="_blank"> */}
                                                    <a href={homepage.footer_section.follow_us.telegram}>
                                                        <i className="fab fa-telegram-plane"></i>
                                                    </a>
                                                    {/* </Link> */}
                                                </li>
                                                <li>
                                                    {/* <Link to={{ pathname: homepage.footer_section.follow_us.skype }} target="_blank"> */}
                                                    <a href={homepage.footer_section.follow_us.skype}>
                                                        <i className="fab fa-skype"></i>
                                                    </a>
                                                    {/* </Link> */}
                                                </li>
                                                <li>
                                                    {/* <Link to={{ pathname: homepage.footer_section.follow_us.wifi }} target="_blank"> */}
                                                    <a href={homepage.footer_section.follow_us.wifi}>
                                                        <i className="fas fa-rss"></i>
                                                    </a>
                                                    {/* </Link> */}
                                                </li>
                                                <li>
                                                    {/* <Link to={{ pathname: homepage.footer_section.follow_us.whatsapp }} target="_blank"> */}
                                                    <a href={homepage.footer_section.follow_us.whatsapp}>
                                                        <i className="fab fa-whatsapp"></i>
                                                    </a>
                                                    {/* </Link> */}
                                                </li>
                                            </ul>
                                        </div> : null}

                                    </div>
                                </Col>
                                <Col xl={6} lg={{ span: 6, order: 2 }} md={12} sm={12} xs={12}>
                                    {homepage.footer_section.quick_links ?
                                        <div className="footer_item" >
                                            {homepage.footer_section.quick_links.footer_menu.length > 0 || '' ? <div className="footer_title">
                                                <h4>{homepage.footer_section.quick_links.title}</h4>
                                            </div> : null}
                                            {homepage.footer_section.quick_links.footer_menu.length > 0 || '' ? <div className="quick_links">
                                                <ul className="list-unstyled">
                                                    {homepage.footer_section.quick_links.footer_menu.map((item, index) => (
                                                        <li key={index}>
                                                            <Link to={item.menu_url}>{item.menu_title}</Link>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div> : null}
                                        </div> : null}
                                </Col>
                            </Row>
                        </div>
                        <hr className="footer_separator" />
                        <div className="copyright_area">
                            <Row className="align-items-center">
                                <Col xl={4} lg={{ span: 4, order: 2 }} md={12} sm={12} xs={12}>
                                    <div className="payment_options">
                                        <ul className="list-inline">
                                            <li>
                                                <img src={images.payOption1} alt="..." />
                                            </li>
                                            <li>
                                                <img src={images.payOption2} alt="..." />
                                            </li>
                                            <li>
                                                <img src={images.payOption3} alt="..." />
                                            </li>
                                            <li>
                                                <img src={images.payOption4} alt="..." />
                                            </li>
                                        </ul>
                                    </div>
                                </Col>
                                {homepage.footer_section.powered_by ? <Col xl={8} lg={{ span: 8, order: 1 }} md={12} sm={12} xs={12}>
                                    <ul className="list-inline copyright_line">
                                        <li><i className="fal fa-copyright"></i> Copyright {homepage.footer_section.powered_by.Copyright}</li>
                                        <li>All Rights Reserved</li>
                                        <li>Powered by <Link to={{ pathname: homepage.footer_section.powered_by.link }} target="_blank">{homepage.footer_section.powered_by.title}</Link></li>
                                    </ul>
                                </Col> : null}
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Container> : null}
        </div >
    )
    // }
}

export default Footer;
